import { render, staticRenderFns } from "./BtnAction.vue?vue&type=template&id=80c253ec&scoped=true&"
import script from "./BtnAction.vue?vue&type=script&lang=js&"
export * from "./BtnAction.vue?vue&type=script&lang=js&"
import style0 from "./BtnAction.vue?vue&type=style&index=0&id=80c253ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c253ec",
  null
  
)

export default component.exports